import { BrowserRouter as Router, Routes, Route, useLocation, } from "react-router";
import { useEffect } from "react";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import Home from "./pages/Dashboard/Home";
import AllOrders from "./components/Transactions/AllOrders";
import PrivateRoute from "./utils/privateRoute";
import KybStatusPage from "./pages/OtherPage/KybStatus";
import PaymentLink from "./components/PaymentLink/PaymentLink";
import PaymentLinkPay from "./pages/OtherPage/PaymentLinkPay";
import Webhooks from "./components/webhooks/Webhooks";
import Wallet from "./components/wallet/Wallet";
import TransactionsPage from "./components/wallet/TransactionsPage";
import Crypto from "./components/crypto/Crypto";
import CryptoTransactionsPage from "./components/crypto/CryptoTransactionsPage";
import WalletPaymentLinks from "./components/WalletPaymentLink/WalletPaymentLinks";
import WalletPaymentLinkPay from "./components/WalletPaymentLink/WalletPaymentLinkPay";

// --- ENV ---
const GA_ID = import.meta.env.VITE_GA_ID;

// --- SPA TRACKER ---
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag && GA_ID) {
      window.gtag("config", GA_ID, {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};

export default function App() {
  return (
    <>
      <Router>
        <AnalyticsTracker /> {/* ✅ SPA tracking */}
        <ScrollToTop />
        <Routes>
          {/* Protected routes  */}
          <Route
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          >
            <Route index path="/dashboard" element={<Home />} />
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/exchanges" element={<AllOrders />} />
            <Route path="/payment-link" element={<PaymentLink />} />
            <Route path="/wallet-payment-link" element={<WalletPaymentLinks />} />
            <Route path="/webhooks" element={<Webhooks />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/stablecoin" element={<Crypto />} />
            {/* <Route path="/stablecoin" element={<Crypto />} /> */}
            <Route path="/stablecoin/transactions" element={<CryptoTransactionsPage />} />
            <Route path="/wallet/transactions/:currency" element={<TransactionsPage/>} />

          </Route>

          {/* Auth Layout route */}
          <Route path="/" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />

          {/* Kyb Route route */}
          <Route path="/kyb/verification/status" element={<KybStatusPage />} />

          {/* Payment Link route */}
          <Route path="/payment-link/pay" element={<PaymentLinkPay />} />
          <Route path="/wallet-pay/:token" element={<WalletPaymentLinkPay />} />

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
